// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {InputHTMLAttributes, MutableRefObject} from 'react';
import cn from 'classnames';
import styles from './basic_input.module.less';

export type t_content = string | JSX.Element;
export type t_render_prop = (value?: string)=>JSX.Element;

export interface i_basic_input_props {
    type?: InputHTMLAttributes<HTMLInputElement>['type'];
    value?: string;
    placeholder?: string;
    label?: t_content;
    is_disabled?: boolean;
    is_error?: boolean;
    cls?: string;
    input_props?: InputHTMLAttributes<HTMLInputElement>;
    slot_left?: JSX.Element | t_render_prop;
    slot_right?: JSX.Element | t_render_prop;
    slot_bottom?: JSX.Element | t_render_prop;
    input_ref?: MutableRefObject<HTMLInputElement>,
    on_change?: (value?: string)=>void;
    on_blur?: (value?: string)=>void;
    icon_left?: JSX.Element;
}

export const Basic_input = (props: i_basic_input_props)=>{
    const {
        type = 'text',
        value,
        placeholder,
        label,
        is_disabled,
        is_error,
        slot_left,
        slot_right,
        slot_bottom,
        cls,
        on_change,
        on_blur,
        input_ref,
        input_props = {},
        icon_left,
    } = props;
    const root_cls = cn(styles.basic_input, cls,
        is_error && styles.is_error,
        is_disabled && styles.is_disabled,
    );
    return <div className={root_cls}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles.wrapper}>
        {typeof slot_left=='function' ? slot_left() : slot_left}
        {icon_left && icon_left}
        <input
          ref={input_ref}
          type={type}
          value={value}
          placeholder={placeholder}
          disabled={is_disabled}
          onChange={ev=>{ on_change?.(ev.target.value); }}
          onBlur={ev=>{ on_blur?.(ev.target.value); }}
          {...input_props}
        />
        {typeof slot_right=='function' ? slot_right() : slot_right}
      </div>
      {typeof slot_bottom=='function' ? slot_bottom() : slot_bottom}
    </div>;
};
